import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ViewStreamOutlinedIcon from "@mui/icons-material/ViewStreamOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { connect, useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import verticalIcon from "../../img/mobileIcon/Button-Category.png";
import {
  selectIsOverlayVisible,
  toggleOverlay,
} from "../../store/slices/headerSlice";
import MobileSideBar from "./MobileSideBar";
import MobileBigNavigation from "./MobileBigNavigation";
import { useMediaQuery } from "react-responsive";
import AutoLoginPage from "../MobileAuthentication/AutoLoginPage/AutoLoginPage";
import { selectAllCarts } from "../../features/cartPage/cartPageSlice";

function MobileBottomNavigation({ isOverlayVisible, toggleOverlay }) {
  const [openBurger, setOpenBurger] = useState(false);
  const [showNavigation, setShowNavigation] = useState(false);
  const [showAutoLogin, setShowAutoLogin] = useState(false);
  const userDetail = useSelector(selectUser);
  const navigate = useNavigate();
  const location = useLocation();
  const cart = useSelector(selectAllCarts);
const cartCount = Array.isArray(cart) ? cart?.length : 0;


  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });

  const isCurrentPath = (path) => location.pathname === path;

  const handleNavigate = (path) => {
    if (!path) return;
    navigate(path);
  };

  // Auto-login popup delay for guest users
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!Object.keys(userDetail).length) setShowAutoLogin(true);
    }, 6000);
    return () => clearTimeout(timer);
  }, [userDetail]);

  return (
    <>
      {/* Floating rounded bottom bar */}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[92%] max-w-[720px] bg-white-1 shadow-xl rounded-full flex items-center justify-between py-0 px-4 z-[999] backdrop-blur-sm border border-gray-100">
        {/* Home */}
        <button
          aria-label="Home"
          className="flex flex-col items-center justify-center gap-1 w-[20%] sm:w-auto active:scale-95 transition-all"
          onClick={() => handleNavigate("/")}
        >
          <HomeOutlinedIcon
            style={{
              fontSize: 26,
              color: isCurrentPath("/")
                ? "var(--color-peach)"
                : "var(--color-blue)",
              transition: "all 0.25s",
            }}
          />
          <span
            className={`text-[12px] font-semibold ${isCurrentPath("/") ? "text-peach" : "text-blue"
              }`}
          >
            Home
          </span>
        </button>

        {/* Orders */}
        <button
          aria-label="Orders"
          className="flex flex-col items-center justify-center gap-1 w-[20%] sm:w-auto active:scale-95 transition-all"
          onClick={() =>
            Object.keys(userDetail).length
              ? handleNavigate("/user/orders")
              : toggleOverlay()
          }
        >
          <ViewStreamOutlinedIcon
            style={{
              fontSize: 26,
              color: isCurrentPath("/user/orders")
                ? "var(--color-peach)"
                : "var(--color-blue)",
              transition: "all 0.25s",
            }}
          />
          <span
            className={`text-[12px] font-semibold ${isCurrentPath("/user/orders") ? "text-peach" : "text-blue"
              }`}
          >
            Orders
          </span>
        </button>

        {/* Center Floating Button container (space reserved) */}
        <div className="relative flex items-center justify-center w-[24%] sm:w-auto">
          {/* Elevated circular button (centered above the bar) */}
          <button
            aria-label="Categories"
            onClick={() => setShowNavigation(true)}
            className=" text-white-1 rounded-full w-[65px] h-[65px] flex items-center justify-center"
          >
            <img
              src={verticalIcon}
              alt="categories"
              className="w-full h-full object-contain"
            />
          </button>
        </div>

        {/* Cart */}
        <button
          aria-label="Cart"
          className="relative flex flex-col items-center justify-center gap-1 w-[20%] sm:w-auto active:scale-95 transition-all"
          onClick={() =>
            Object.keys(userDetail).length
              ? handleNavigate("/carts")
              : toggleOverlay()
          }
        >
          <ShoppingCartOutlinedIcon
            style={{
              fontSize: 26,
              color: isCurrentPath("/carts")
                ? "var(--color-peach)"
                : "var(--color-blue)",
              transition: "all 0.25s",
            }}
          />

          {/* 🔹 Cart count badge */}
          {cartCount > 0 && (
            <span className="absolute -top-1.5 right-3 min-w-5 h-5 bg-[goldenrod] text-white-1 text-[10px] font-bold rounded-full flex items-center justify-center shadow-md">
              {cartCount > 9 ? "9+" : cartCount}
            </span>
          )}

          <span
            className={`text-[12px] font-semibold ${isCurrentPath("/carts") ? "text-peach" : "text-blue"
              }`}
          >
            Cart
          </span>
        </button>


        {/* Profile */}
        <button
          aria-label="Profile"
          className="flex flex-col items-center justify-center gap-1 w-[20%] sm:w-auto active:scale-95 transition-all"
          onClick={() =>
            Object.keys(userDetail).length
              ? setOpenBurger(true)
              : toggleOverlay()
          }
        >
          <AccountCircleOutlinedIcon
            style={{
              fontSize: 26,
              color: openBurger ? "var(--color-peach)" : "var(--color-blue)",
              transition: "all 0.25s",
            }}
          />
          <span
            className={`text-[12px] font-semibold ${openBurger ? "text-peach" : "text-blue"
              }`}
          >
            Profile
          </span>
        </button>
      </div>

      {/* MobileBigNavigation (overlayed modal/navigation) */}
      {showNavigation && (
        <MobileBigNavigation
          setShowNavigation={setShowNavigation}
          showNavigation={showNavigation}
        />
      )}

      {/* Mobile sidebar for profile */}
      {openBurger && (
        <MobileSideBar setOpenBurger={setOpenBurger} openBurger={openBurger} />
      )}

      {/* Auto login suggestion for guests */}
      {isTabletOrMobile && showAutoLogin && !userDetail?.UserID && (
        <AutoLoginPage setShowAutoLogin={setShowAutoLogin} />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});

const mapDispatchToProps = {
  toggleOverlay,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileBottomNavigation);
